import type { UserImageProps } from "@circle-react-uikit/UserImage";
import { UserImageWithFallback } from "@/react/components/shared/uikit/UserImageWithFallback";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import "./styles.scss";

export interface ParticipantAvatarProps {
  name: string;
  size?: "xl" | "lg" | "md" | "sm";
  src: string;
  variant?: "circle" | "rounded-square" | "full";
}

/**
 * This component is deprecated.
 *
 * Use {@link @circle-react-uikit/UserImage} component instead
 */
export const ParticipantAvatar = ({
  name,
  src,
  size = "sm",
  variant = "rounded-square",
}: ParticipantAvatarProps) => {
  let imageSize: UserImageProps["size"] = "10";
  if (size === "xl") imageSize = "24";
  if (size === "lg") imageSize = "16";
  if (size === "md") imageSize = "7";

  return (
    <div
      className={classNames("participant-avatar relative", {
        "participant-avatar--lg": size === "lg",
        "participant-avatar--md": size === "md",
        "participant-avatar--sm": size === "sm",
        "participant-avatar--xl": size === "xl",
        "participant-avatar--circle": variant === "circle",
        "participant-avatar--full": variant === "full",
        "participant-avatar--rounded-square": variant === "rounded-square",
      })}
    >
      <UserImageWithFallback name={name} src={src} size={imageSize} />
    </div>
  );
};
